module.exports = __webpack_public_path__ + "static/character-1-cd139e23bfd0cd2fcfe7e3ca3b6dea11.svg";